<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted () {
    window.unbeforeunload = () => { };
  },
  data () {
    return {

    };
  },
  methods: {
    setRem () {
      // 原生rem适配
      // let designSize = 1440; // 设计图尺寸
      // let html = document.documentElement;
      // let wW = html.clientWidth;// 窗口宽度
      // let rem = wW * 100 / designSize;
      // document.documentElement.style.fontSize = rem + 'px';

      //postcss-pxtorem px转rem

      let html = document.documentElement;
      let wW = html.clientWidth > 1360 ? html.clientWidth : 1360; // 窗口宽度
      let rem = wW / 10;
      document.documentElement.style.fontSize = rem + 'px';
    },
    onresize () {
      window.onresize = () => {
        this.setRem();
      };
    }
  }
};
</script>
<style lang="scss">
body .el-table th.gutter {
  display: table-cell !important;
}

.tox-notifications-container {
  display: none !important;
}

// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   width: 100%;
//   height: 100%;
// }
// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
// html{
//   font-size: 192px;
// }
// body{
//   font-size: 16px;
// }
</style>
